export const FormSectionsFNMA = [
	'overview',
	'arrival',
	'site',
	'structures',
	'pdfreview',
	'photoreview',
	'virtualtour'
];

export const UiSectionsFNMA = FormSectionsFNMA;

export enum RulesBaseFNMA {
	OVERVIEW = 1000,
	REVISIONS = 1000,
	ARRIVAL = 2000,
	SITE = 3000,
	STRUCTURES = 4000,
	PDFREVIEW = 5000,
	PHOTOREVIEW = 6000,
	VIRTUALTOUR = 7000
}
